import { Box } from "@mui/material";

export function StatusDot(props: { color: string }) {
  return <Box width={12} height={12} sx={{ borderRadius: "50%", backgroundColor: props.color, display: "inline-block" }}></Box>;
}
